import API from "../API";
import { AxiosResponse } from "axios";

export const listAdmins = (page: string): Promise<AxiosResponse> =>
  API.get(`/admin/users/list?page=${page}`);

export const listAdminById = (id: string): Promise<AxiosResponse> =>
  API.get(`/admin/users/list?id=${id}`);

type AdminCreatePayload = {
  name: string;
  email: string;
  subtype: "admin";
};

export const createAdmin = (
  payload: AdminCreatePayload
): Promise<AxiosResponse> => {
  Object.assign(payload, { phone: "1233214444" });
  return API.post("/admin/users/create", payload);
};

export const editAdmin = (
  id: string,
  payload: AdminCreatePayload
): Promise<AxiosResponse> => {
  Object.assign(payload, { phone: "1233214444" });
  return API.put(`/admin/users/edit/${id}`, payload);
};

export const deleteAdmin = (id: string): Promise<AxiosResponse> =>
  API.delete(`/admin/users/remove/${id}`);
